<script setup lang="ts">
import RectangleCushion from './Forms/RectangleCushion.vue'
import CircleCushion from './Forms/CircleCushion.vue'
import { computed, ref, watchEffect, toRefs } from 'vue'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'

const store = useStore()
const {isButtons, buttonsCols, buttonsRows, isStitches, stitchesCols, stitchesRows} = storeToRefs(store)
const props = defineProps({
  parentWidth: Number,
  parentHeight: Number,
})

const { parentWidth, parentHeight } = toRefs(props)

const emit = defineEmits(['onformdraw'])

const canvasWidth = ref(props.parentWidth || 0)
const canvasHeight = ref(props.parentHeight || 0)

const isValidRender = computed(() => {
  if(isButtons.value == 'buttons_yes' && Number(buttonsCols.value) * Number(buttonsRows.value) > 20) {
    return false
  }
  if(isStitches.value == 'stitches_yes' && Number(stitchesCols.value) * Number(stitchesRows.value) > 20) {
    return false
  }

  return true
})
const formComponent = computed(() =>
  store.isCircle ? CircleCushion : store.isRectangle ? RectangleCushion : null,
)

watchEffect(() => {
  canvasWidth.value = parentWidth?.value || 0
  canvasHeight.value = parentHeight?.value || 0
})

const saveCushionImage = () => {
  emit('onformdraw')
}
</script>

<template>
  <component
    :is="formComponent"
    v-if="canvasWidth && canvasHeight && isValidRender"
    :width="canvasWidth"
    :height="canvasHeight"
    @onformdraw="saveCushionImage"
  />
</template>

<style scoped></style>
